import React, { useEffect, useRef, useState } from "react";
import { Box, Stepper, Step, StepLabel, Typography, Modal, useMediaQuery,  Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import DeleteIcon from "../../../assets/icons/delete-red.svg";

import PersonalDetails from "./PersonalDetails";
import ContactDetails from "./ContactDetails";
import ProfessionalDetails from "./ProfessionalDetails";
import "./style.scss";
import PersonalDetailStepIcon from "../../../assets/component-icon/PersonalDetailStepIcon";
import ContactDetailStepIcon from "../../../assets/component-icon/ContactDetailStepIcon";
import ProfessionalDetailStepIcon from "../../../assets/component-icon/ProfessionalDetailStepIcon";
import { APPLICANT_NUMBER_WORD } from "../../../config/constant";
import { setApplicantActiveStep, deleteApplicantDetailsForm,setApplicantTotal } from "../voucher-form.slice";
import SnackbarAlert from "../../../shared-components/snackbar-alert/SnackbarAlert";
import DeleteConfirmationModal from "../../../shared-components/delete-confirmation-modal/DeleteConfirmationModal";
import StepperIconRoot from "../../../shared-components/stepper/StepperIconRoot";

const ApplicantDetail = ({ applicantNo }) => {
  const dispatch = useDispatch();
  const { voucherId } = useParams();
  const personalDetailsRef = useRef();
  const contactDetailsRef = useRef();
  const professionalDetailsRef = useRef();
  const { applicantActiveStep, applicantData, activeStep, applicantTotal, applicantEditPreview } = useSelector(
    (state) => state.voucherForm
  );
  
  const [applicantDetails, setApplicantDetails] = useState(null);
  const stepsApplicantDetails = [
    "Personal Details",
    "KYC Details",
    "Professional Details",
  ];
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [nextStep, setNextStep] = useState(null); 
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const isMobile = useMediaQuery("(max-width: 767px)");
  const stepperRef = useRef(null);
  const currentApplicantKey = `applicant${applicantNo}`;
  const currentApplicantData = applicantDetails?.[currentApplicantKey];

  useEffect(() => {
    if (isMobile && stepperRef.current) {
      if (applicantActiveStep === stepsApplicantDetails.length - 1) {
        // Scroll to the right when the last step is active
        stepperRef.current.scrollTo({
          left: stepperRef.current.scrollWidth, 
          behavior: "smooth",
        });
      } else {
        // Scroll back to the left for other steps
        stepperRef.current.scrollTo({
          left: 0, 
          behavior: "smooth",
        });
      }
    }
  }, [applicantActiveStep, isMobile]);
  

  useEffect(() => {
    if (applicantData) {
      setApplicantDetails(applicantData);
    }
  }, [applicantData]);
  const [snackbarConfig, setSnackbarConfig] = useState({
    open: false,
    message: "",
    severity: "",
  });


function ColorlibStepIcon(props) {
  const { active, className, icon } = props;

  const applicantKey = `applicant${props.applicantNo}`;
  const currentApplicant = applicantDetails?.[applicantKey];

  const isCompleted1 = icon === 1 && currentApplicant?.personalDetails && applicantActiveStep !== 0;
  const isCompleted2 = icon === 2 && currentApplicant?.contactDetails && applicantActiveStep !== 1;
  const isCompleted3 = icon === 3 && currentApplicant?.professionalDetails && applicantActiveStep !== 2;

  const icons = {
    1: <PersonalDetailStepIcon show={active} completed={isCompleted1} />,
    2: <ContactDetailStepIcon show={active} completed={isCompleted2} />,
    3: <ProfessionalDetailStepIcon show={active} completed={isCompleted3} />,
  };

  return (
    <StepperIconRoot
      ownerState={{
        active,
        isCompleted1,
        isCompleted2,
        isCompleted3,
        variant: "colorlib",
      }}
      className={className}
    >
      {icons[icon]}
    </StepperIconRoot>
  );
}

  const handleStep = (step) => () => {
    const currentApplicant =
      applicantNo === 1
        ? applicantDetails?.applicant1
        : applicantDetails?.applicant2;
  
    const hasPersonalDetails = currentApplicant?.personalDetails;
    const hasContactDetails = currentApplicant?.contactDetails;
    const hasProfessionalDetails = currentApplicant?.professionalDetails;
  
    if (step === 1 && !(hasPersonalDetails)) {
      
      return; 
    }
    if (step === 1 && !(hasContactDetails)) {
      
      return; 
    }
    if (step === 2 && !(hasPersonalDetails && hasContactDetails)) {
      
      return; 
    }
  
    if (
      (step === 0 && applicantActiveStep === 1 && hasPersonalDetails && !hasContactDetails) || 
      (step === 1 && applicantActiveStep === 2 && hasContactDetails && !hasProfessionalDetails) || 
      (step === 0 && applicantActiveStep === 2 && hasPersonalDetails && !hasProfessionalDetails) 
    ) {
      setShowConfirmDialog(true);
      setNextStep(step); 
      return; 
    }

    if(hasPersonalDetails && hasContactDetails && hasProfessionalDetails){
      if((professionalDetailsRef?.current && Object.keys(professionalDetailsRef?.current?.errors).length > 0) ||
        (contactDetailsRef?.current && Object.keys(contactDetailsRef?.current?.errors).length > 0) ||
        (personalDetailsRef?.current && Object.keys(personalDetailsRef?.current?.errors).length > 0)){
          setSnackbarConfig({
            open: true,
            message: "Please fill all the mandatory fields",
            severity: "error",
          });
          return;
      }
      if(applicantActiveStep === 2){
        if(professionalDetailsRef?.current){
          professionalDetailsRef?.current.saveUpdatedData()
          step = step -1
        }
      }
  
      if(applicantActiveStep === 1){
        if(contactDetailsRef?.current){
          contactDetailsRef?.current.handleSaveForm()
          step = step -1
        }
      }
  
      if(applicantActiveStep === 0){
        if(personalDetailsRef?.current){
          personalDetailsRef?.current.handleSaveForm()
          step = step -1
        }
      }
    }
  
    if (applicantActiveStep !== step) {
      dispatch(setApplicantActiveStep(step));  
    }
    if (step === 1) {
      dispatch(setApplicantActiveStep(step));  
    }
  };
  
  
  
  
  const handleDialogClose = (confirm) => {
    setShowConfirmDialog(false);
    if (confirm && nextStep !== null) {
      dispatch(setApplicantActiveStep(nextStep)); // Navigate to the stored step
    }
  };
  const handleSnackbarClose = () => {
    setSnackbarConfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleDeleteClick = () => {
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    setIsDeleting(true);

    if(!applicantData[`applicant${applicantNo}`]){
      dispatch(setApplicantTotal(applicantNo - 1));
      return;
    }
    try {
      await dispatch(deleteApplicantDetailsForm({
        voucherId: voucherId,
        applicantNo: applicantNo,
        previousStep: activeStep - 1
      })).unwrap();
      setDeleteDialogOpen(false);
      setSnackbarConfig({
        open: true,
        message: `Applicant ${applicantNo} deleted successfully`,
        severity: "success",
      });
    } catch (error) {
      console.error('Error deleting applicant:', error);
      setSnackbarConfig({
        open: true,
        message: "Failed to delete applicant. Please try again.",
        severity: "error",
      });
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
  };
  useEffect(()=>{
    if(applicantActiveStep===2 && !currentApplicantData?.contactDetails && applicantEditPreview){
      dispatch(setApplicantActiveStep(0))
    }
  },[applicantData])

  return (
    <>
      {/* Applicant Details Title with Delete Button */}
      <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography
          sx={{
            color: "#1C252E",
            fontSize: "16px",
            fontWeight: "600",
            lineHeight: "36px",
            textAlign: "center",
            flex: 1
          }}
        >
          {applicantNo === 1 ? "Primary" : `${applicantNo}`}
          {applicantNo !== 1 && <sup>{APPLICANT_NUMBER_WORD[applicantNo - 1]}</sup>} Applicant Details
        </Typography>
        {applicantNo !== 1 && applicantNo === applicantTotal  && (
        <Button
          onClick={handleDeleteClick}
          startIcon={
            <img 
              src={DeleteIcon} 
              alt="delete" 
              style={{ width: 20, height: 20 }}
            />
          }
          sx={{
            color: "#d32f2f",
            textTransform: "none",
            fontWeight: 500,
            "&:hover": {
              backgroundColor: "#ffebee"
            }
          }}
        >
          Delete Applicant
        </Button>

        )}
      </Box>
      <Box sx={{ width: "100%" }}>
        <Stepper
          activeStep={applicantActiveStep}
          sx={{ mb: 3 }}
          ref={stepperRef}
          className="steeperPersonal"
        >
          {stepsApplicantDetails.map((label, index) => {
            const stepProps = {};
           
            return (
              <Step
                key={label}
                {...stepProps}
                onClick={handleStep(index)}
                sx={{
                  "& .MuiStepLabel-root": {
                    color:  "green",
                    cursor: "pointer",
                    
                  },
                  "& .MuiStepLabel-label.Mui-active": {
                    color: "#1A407D",
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "22px",
                  },
                  "& .MuiStepIcon-root": {
                    background: "#fff",
                    color: "#fff",
                    width: "32px",
                    height: "32px",
                    border: "2px solid #A5A5A5",
                    borderRadius: "10000px",
                    "& .css-117w1su-MuiStepIcon-text": {
                      fill: "#1A407D",
                    },
                  },
                  "& .MuiStepIcon-root.Mui-active": {
                    background: "red",
                    border: "2px solid #1A407D",
                    color: "#fff",
                  },
                  
                  
                }}
              >
              <StepLabel
                StepIconComponent={(props) => (
                  <ColorlibStepIcon {...props} applicantNo={applicantNo} />
                )}
              >
                {label}
              </StepLabel>

              </Step>
            );
          })}
        </Stepper>
      </Box>
      <Modal
  open={showConfirmDialog}
  onClose={() => handleDialogClose(false)}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
  className="saveLaterModal"
  hideBackdrop={true}
  disableEscapeKeyDown={true}
>
  <div className="modalContainer">
    <Box sx={{ border: "0" }}>
      <Typography
        className="modalTitle"
        id="modal-modal-title"
        variant="h6"
        component="h2"
      >
        You have unsaved changes. Are you sure you want to proceed?
      </Typography>
      <Typography
        className="modalTitle"
        id="modal-modal-title"
        variant="h6"
        component="h2"
      >
        OR
      </Typography>
      <Typography
        className="modalTitle"
        id="modal-modal-title"
        variant="h6"
        component="h2"
      >
        Click on Save For later and proceed
      </Typography>
    </Box>
    <div className="btnSignLateModal titleDear marginTop">
      <button
        onClick={() => {
          handleDialogClose(true);
        }}
      >
        Yes
      </button>
      <button
        onClick={() => {
          handleDialogClose(false);
        }}
      >
        No
      </button>
    </div>
  </div>
</Modal>

      
      {(applicantActiveStep === 0 || applicantActiveStep === -1) && (
        <PersonalDetails applicantNo={applicantNo} ref={personalDetailsRef}/>
      )}
      {applicantActiveStep === 1 && <ContactDetails applicantNo={applicantNo} ref={contactDetailsRef}/>}
      {applicantActiveStep === 2 && (
        <ProfessionalDetails applicantNo={applicantNo} ref={professionalDetailsRef}/>
      )}
      <SnackbarAlert
          open={snackbarConfig.open}
          message={snackbarConfig.message}
          severity={snackbarConfig.severity}
          onClose={handleSnackbarClose}
        />
      
      {/* Delete Confirmation Modal */}
      <DeleteConfirmationModal
        open={deleteDialogOpen}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        title="Delete Applicant"
        message={`Are you sure you want to delete ${applicantNo}${APPLICANT_NUMBER_WORD[applicantNo - 1]} Applicant? This action cannot be undone and all data for this applicant will be permanently removed.`}
        applicantNo={applicantNo}
        loading={isDeleting}
      />
    </>
  );
};

export default ApplicantDetail;
